import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { FocuspayReportingService } from 'src/app/core/services/focuspay-reporting.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { DatacapBatchRecord } from 'src/app/shared/models/DTO/FocusPayDatacap/DatacapReportSummary.dto';

@Component({
	selector: 'app-batch-list',
	templateUrl: './batch-list.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class BatchListComponent implements OnInit, OnDestroy {
	@Input() merchantId: string;

	batchRecords: DatacapBatchRecord[] = [];
	batchRecordSubscription: Subscription;

	totalBatchRecords = 0;

	lastFetchRow: number = 0;
	loading: boolean = true;
	recordsToDisplay: number = 10;

	constructor(
		public app: AppService,
		public venueService: OOVenueService,
		public focusPayReportingService: FocuspayReportingService,
		private router: Router
	) {}

	ngOnDestroy(): void {
		this.batchRecordSubscription.unsubscribe();
	}

	ngOnInit(): void {
		this.app.loading(true);
		this.batchRecordSubscription = this.focusPayReportingService.batchRecords.subscribe((batchRecords) => {
			if (batchRecords.length > 0) {
				this.batchRecords = batchRecords.slice(this.lastFetchRow, this.lastFetchRow + this.recordsToDisplay);
				this.totalBatchRecords = batchRecords[0].number;
				this.loading = false;
			} else {
				this.batchRecords = [];
			}
		});
	}

	fetchAdditionalRecords(event) {
		this.loading = true;
		this.lastFetchRow = event.first;
		this.recordsToDisplay = event.rows;
		this.focusPayReportingService.fetchTransactionRecords(
			this.venueService.subscriptionVenue.value.key,
			this.merchantId || this.venueService.subscriptionVenue.value.ccProcessorApiKey,
			event.first,
			event.rows
		);
	}

	selectRecord(batchNumber: number) {
		this.router.navigate([`/cc/credit/batch/${batchNumber}`]);
	}
}
